<div class="d-flex flex-row justify-content-start align-items-start">
    <div class="flex-fill">
        <p-panel class="p-fluid" iconPos="end" [toggleable]="true" [collapsed]="false" expandIcon="pi pi-chevron-up" collapseIcon="pi pi-chevron-down">
            <ng-template pTemplate="header">
                <div class="container notMobile">
                    <div class="d-flex justify-content-between">
                        <div class="flex-item mt-2 mb-2">
                            <span class="section-header">Search Criteria</span>
                        </div>
                        <div class="flex-item mt-2 mb-2">
                            <a class="btn btn-secondary btn-sm me-2" href="/"><i class="fas fa-magnifying-glass"></i>
                                New Search</a>
                            <button type="button" class="btn btn-secondary btn-sm me-2" (click)="submitForm();"><i
                                    class="fas fa-magnifying-glass-plus"></i> Edit Search</button>
                            <button type="button" class="btn btn-secondary btn-sm me-2" (click)="saveSearch();"><i
                                    class="fa fa-floppy-disk"></i> Save Search</button>
                            <button type="button" class="btn btn-secondary btn-sm me-2" (click)="copyClipboard();"><i
                                    class="fas fa-copy"></i> Copy Search</button>
                        </div>
                    </div>
                </div>
                <div class="container forMobile">
                    <div>
                        <div class="mt-2 mb-2" style="display: block;">
                            <span>Search Criteria</span>
                        </div>
                        <div class="mt-2 mb-2"  style="display: block;">
                            <a class="btn btn-secondary btn-sm me-2" href="/">New</a>
                            <button type="button" class="btn btn-secondary btn-sm me-2" (click)="submitForm();">Edit</button>
                            <button type="button" class="btn btn-secondary btn-sm me-2" (click)="saveSearch();">Save</button>
                            <button type="button" class="btn btn-secondary btn-sm me-2" (click)="copyClipboard();">Copy</button>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="row mt-3 mb-3 ">
                <div class="col-12 col-sm-2 col-lg-2"><strong>Search Term(s):</strong></div>
                <div class="col-12 col-sm-10 col-lg-10">{{query.keywords}}</div>
            </div>
            <div class="row mt-3 mb-3 ">
                <div class="col-12 col-sm-2 col-lg-1"><strong>Libraries:</strong></div>
                <div class="col-12 col-sm-10 col-lg-11">{{query.options?.join(',  ') }}</div>
            </div>
          
            <div class="pt-3" *ngIf="query.allProps?.length > 0|| query.anyProps?.length>0">
                <span class="searchCriteriaLabel">Property Filters:</span><br />
                <div class="row ms-2">
                    <div class="col-6">
                        <p><span class="searchCriteriaLabel">Where ALL the following is true:</span></p>
                        <span *ngFor="let cp of query.allProps">
                            <span *ngIf="!cp.isDate">
                                <p>
                                    <span *ngIf="cp.textOperator==constants.text_operator_contains">
                                        <strong>{{cp.displayName}}</strong> <em> contains</em> {{cp.keywords}}
                                    </span>
                                    <span *ngIf="cp.textOperator==constants.text_operator_contains_not">
                                        <strong>{{cp.displayName}}</strong> <em> does not contain</em> {{cp.keywords}}
                                    </span>
                                    <span *ngIf="cp.textOperator==constants.text_operator_starts">
                                        <strong>{{cp.displayName}}</strong> <em> starts with</em> {{cp.keywords}}
                                    </span>
                                    <span *ngIf="cp.textOperator==constants.text_operator_starts_not">
                                        <strong>{{cp.displayName}}</strong> <em> does not start with</em> {{cp.keywords}}
                                    </span>
                                    <span *ngIf="cp.textOperator==constants.text_operator_equals">
                                        <strong>{{cp.displayName}}</strong> <em> equals</em> {{cp.keywords}}
                                    </span>
                                    <span *ngIf="cp.textOperator==constants.text_operator_equals_not">
                                        <strong>{{cp.displayName}}</strong> <em> does not equal</em> {{cp.keywords}}
                                    </span>
                                </p>
                            </span>
                            <span *ngIf="cp.isDate">
                                <p>
                                    <span *ngIf="cp.dateOperator=='between'"><strong>{{cp.displayName}}</strong>
                                        <em> between</em>
                                        {{cp.startDate
                                        | date}} {{ cp.startTime }}<em> and</em> {{cp.endDate |
                                        date}} {{ cp.endTime }}</span>
                                    <span *ngIf="cp.dateOperator=='ends'"><strong>{{cp.displayName}}</strong> <em> &lt;=</em>
                                        {{cp.startDate |
                                        date}} {{ cp.startTime }}</span>
                                    <span *ngIf="cp.dateOperator=='starts'"><strong>{{cp.displayName}}</strong>
                                        <em> &gt;=</em>
                                        {{cp.startDate |
                                        date}} {{ cp.startTime }}</span>
                                    <span *ngIf="cp.dateOperator=='equals'"><strong>{{cp.displayName}}</strong> <em> =</em>
                                        {{cp.startDate
                                        |
                                        date}} {{ cp.startTime }}</span>
                                </p>
                            </span>
                        </span>
                    </div>
                    <div class="col-6">
                        <p><span class="searchCriteriaLabel">Where ANY the following is true:</span></p>
                        <span *ngFor="let cp of query.anyProps">
                            <span *ngIf="!cp.isDate">
                                <p>
                                <span *ngIf="cp.textOperator==constants.text_operator_contains">
                                    <strong>{{cp.displayName}}</strong> <em> contains</em> {{cp.keywords}}
                                </span>
                                <span *ngIf="cp.textOperator==constants.text_operator_contains_not">
                                    <strong>{{cp.displayName}}</strong> <em> does not contain</em> {{cp.keywords}}
                                </span>
                                <span *ngIf="cp.textOperator==constants.text_operator_starts">
                                    <strong>{{cp.displayName}}</strong> <em> starts with</em> {{cp.keywords}}
                                </span>
                                <span *ngIf="cp.textOperator==constants.text_operator_starts_not">
                                        <strong>{{cp.displayName}}</strong> <em> does not start with</em> {{cp.keywords}}
                                </span>
                                <span *ngIf="cp.textOperator==constants.text_operator_equals">
                                    <strong>{{cp.displayName}}</strong> <em> equals</em> {{cp.keywords}}
                                </span>
                                <span *ngIf="cp.textOperator==constants.text_operator_equals_not">
                                    <strong>{{cp.displayName}}</strong> <em> does not equal</em> {{cp.keywords}}
                                </span>
                            </p>
                            </span>
                            <span *ngIf="cp.isDate">
                                <p>
                                <span *ngIf="cp.dateOperator=='between'"><strong>{{cp.displayName}}</strong>
                                    <em> between</em>
                                    {{cp.startDate
                                    | date}} {{ cp.startTime }}<em> and</em> {{cp.endDate |
                                    date}} {{ cp.endTime }}</span>
                                <span *ngIf="cp.dateOperator=='ends'"><strong>{{cp.displayName}}</strong> <em> &lt;=</em>
                                    {{cp.startDate |
                                    date}} {{ cp.startTime }}</span>
                                <span *ngIf="cp.dateOperator=='starts'"><strong>{{cp.displayName}}</strong> <em> &gt;=</em>
                                    {{cp.startDate |
                                    date}} {{ cp.startTime }}</span>
                                <span *ngIf="cp.dateOperator=='equals'"><strong>{{cp.displayName}}</strong> <em> =</em>
                                    {{cp.startDate
                                    |
                                    date}} {{ cp.startTime }}</span>
                                    </p>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </p-panel>
    </div>
</div>
<app-dialog-save-search [saveSearchVisible]="saveSearchVisible" (closeDialog)="closeSaveSearch();"></app-dialog-save-search>
<p-toast key="saveSearch" position="top-left"></p-toast>
<p-toast position="top-left"></p-toast>